<template>
<div class="chapter">
<div class="inner_page">
<p class="ctl" id="d12e132">TABLE OF CONTENTS</p>
<p class="cct" id="d12e134"><a href="#/Rola_1595552685_epub_c8_r1#d12e190" id="d12e135">Chapter 1—Edge of Disaster</a></p>
<p class="cct" id="d12e137"><a href="#/Rola_1595552685_epub_c9_r1#d12e313" id="d12e138">Chapter 2—Tennessee River Boys</a></p>
<p class="cct" id="d12e140"><span href="#/Rola_1595552685_epub_c10_r1#d12e932" id="d12e141" title="Link target outside of Sample">Chapter 3—Marty Roe</span></p>
<p class="cct" id="d12e143"><span href="#/Rola_1595552685_epub_c11_r1#d12e1186" id="d12e144" title="Link target outside of Sample">Chapter 4—Dan Truman</span></p>
<p class="cct" id="d12e146"><span href="#/Rola_1595552685_epub_c12_r1#d12e1401" id="d12e147" title="Link target outside of Sample">Chapter 5—Jimmy Olander</span></p>
<p class="cct" id="d12e149"><span href="#/Rola_1595552685_epub_c13_r1#d12e1655" id="d12e150" title="Link target outside of Sample">Chapter 6—Brian Prout</span></p>
<p class="cct" id="d12e152"><span href="#/Rola_1595552685_epub_c14_r1#d12e1951" id="d12e153" title="Link target outside of Sample">Chapter 7—Gene Johnson</span></p>
<p class="cct" id="d12e155"><span href="#/Rola_1595552685_epub_c15_r1#d12e2166" id="d12e156" title="Link target outside of Sample">Chapter 8—Dana Williams</span></p>
<p class="cct" id="d12e158"><span href="#/Rola_1595552685_epub_c16_r1#d12e2442" id="d12e159" title="Link target outside of Sample">Chapter 9—Wild Ride</span></p>
<p class="cct" id="d12e161"><span href="#/Rola_1595552685_epub_c17_r1#d12e3311" id="d12e162" title="Link target outside of Sample">Chapter 10—Team Rio</span></p>
<p class="cct" id="d12e165"><span href="#/Rola_1595552685_epub_c18_r1#d12e3608" id="d12e166" title="Link target outside of Sample">Chapter 11—Nowhere Bound</span></p>
<p class="cct" id="d12e168"><span href="#/Rola_1595552685_epub_c19_r1#d12e3865" id="d12e169" title="Link target outside of Sample">Chapter 12—Revived</span></p>
<p class="cct" id="d12e171"><span href="#/Rola_1595552685_epub_c20_r1#d12e4340" id="d12e172" title="Link target outside of Sample">Appendix A—Diamond Rio’s Top 20 Country Hits</span></p>
<p class="cct" id="d12e174"><span href="#/Rola_1595552685_epub_c22_r1#d12e4656" id="d12e175" title="Link target outside of Sample">Appendix B—Diamond Rio’s Major Awards and Nominations</span></p>
<p class="cct" id="d12e177"><span href="#/Rola_1595552685_epub_c25_r1#d12e4930" id="d12e178" title="Link target outside of Sample"><i>Career Moments</i></span></p>
<p class="cct" id="d12e181"><span href="#/Rola_1595552685_epub_c27_r1#d12e5003" id="d12e182" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="cct" id="d12e185"><span href="#/Rola_1595552685_epub_c28_r1#d12e5066" id="d12e186" title="Link target outside of Sample"><i>About the Writer</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Rola_1595552685_epub_c7_r1.vue?1992a37c